<template>
  <div>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
      <div class='container-fluid'>
          <div class='col-lg-12' style='padding:0px'>
            <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
              <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
              </ul>
            </div>
            <div class='alert alert-success alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='successShow'>
               {{success}}
            </div>
            <input v-model='record.id' name='id' type='text' hidden>
            <div class='col-lg-3 col-sm-3' style='padding: 10px 0px 0px 10px;'>
                <label>العقد:</label>
                <select @change='FillGrid()' class="form-control" style="padding: 0px" v-model="record.contract_id">
                  <option  v-for="(contract) in $store.state.customerData.contract" v-bind:key="contract.id" v-bind:value="contract.id">
                    {{contract.item}} [{{ contract.id }}]
                  </option>
                </select>
            </div>
                <div class='col-lg-3 col-sm-3' style='padding-top: 10px;'>
                    <tbDate  :mytitle='dateTitle' v-model= 'record.request_date' ></tbDate>
                </div>
                <div class='col-lg-4 col-sm-4' style='padding: 10px 0px 0px 10px;'>
                    <label>الفنى:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.technical_id">
                      <option v-for="technical in technicals" v-bind:key="technical.id" v-bind:value="technical.id">
                        {{ technical.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-2 col-sm-2' style='padding: 10px 0px 0px 10px;'>
                    <label>الحالة:</label>
                    <select class="form-control" style="padding: 0px" v-model="record.status">
                      <option v-for="type in types" v-bind:key="type.id" v-bind:value="type.id">
                        {{ type.name }}
                      </option>
                    </select>
                </div>
                <div class='col-lg-9 col-sm-8' style='padding: 10px 0px 0px 10px;'>
                    <label>المطلوب:</label>
                    <input v-model='record.notes' class='form-control' name='notes' type='text'>
                </div>
                <div class='col-lg-3 col-sm-4' style='padding: 30px 0px 30px 10px;  text-align:center;'>
                  <vue-element-loading size='32' :active='isLoadingSave' spinner='bar-fade-scale' color='#A4A4A4'/>
                  <button v-show="$per.value.saveMaintenanceRequest" @click='showForm(0)'  type='button' class='btn btn-primary btn-outline btn-sm'>جديد</button>
                  <button v-show="($per.value.saveMaintenanceRequest && record.id === 0 ) || ($per.value.editMaintenanceRequest && record.id > 0 )" @click='saveData'  type='button' class='btn btn-outline btn-sm btn-success'>حفظ</button>
                  <button v-show="$per.value.deleteMaintenanceRequest" @click='deleteData(selectedrec)' type='button' class='btn btn-outline btn-danger btn-sm'>حذف</button>
                </div>
            <table width='100%' class='table  table-bordered ' >
                  <thead>
                    <tr>
                        <th style='text-align: center'>التاريخ</th>
                        <th style='text-align: center'>المطلوب</th>
                        <th style='text-align: center'>الفنى</th>
                        <th style='text-align: center'>المسجل</th>
                        <th style='text-align: center'>الحالة</th>
                    </tr>
                  </thead>
                  <tbody v-show="!$per.value.editMaintenanceRequest">
                      <tr v-for='record in records' :key='record.id'>
                        <td style="padding:2px" align='center'>{{record.request_date}}</td>
                        <td style="padding:2px" align='center'>{{record.notes}}</td>
                        <td style="padding:2px" align='center'>{{record.technical_name}}</td>
                        <td style="padding:2px" align='center'>{{record.user_name}}</td>
                        <td v-if="record.status === '0'" style="padding:2px" align='center'>مغلق</td>
                        <td v-if="record.status === '1'" style="padding:2px" align='center'>نشط</td>
                      </tr>
                  </tbody>
                  <tbody v-show="$per.value.editMaintenanceRequest">
                      <tr  :class="{highlight :selectedrec == record.id}"  v-for='record in records' :key='record.id' v-on:click="showForm(record)">
                        <td style="padding:2px" align='center'>{{record.request_date}}</td>
                        <td style="padding:2px" align='center'>{{record.notes}}</td>
                        <td style="padding:2px" align='center'>{{record.technical_name}}</td>
                        <td style="padding:2px" align='center'>{{record.user_name}}</td>
                        <td v-if="record.status === '0'" style="padding:2px" align='center'>مغلق</td>
                        <td v-if="record.status === '1'" style="padding:2px" align='center'>نشط</td>
                      </tr>
                  </tbody>
              </table>
              <!-- /.table-responsive -->
          <!-- /.col-lg-12 -->
          </div>
       </div>
    <!-- /.container-fluid -->
</div>
</template>
<style>
.highlight {
   background-color: #5A9EF5;
}
tr:hover{
   cursor: pointer;
}
</style>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  components: {
    tbDate
  },
  name: 'maintenanceRequest',
  data () {
    return {
      dateTitle: 'تاريخ الطلب',
      validationErrors: '',
      technicals: {},
      records: {},
      record: {},
      types: [{id: 1, name: 'نشط'}, {id: 0, name: 'مغلق'}],
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      selectedrec: null,
      branches: {},
      Localcontract_id: 0
    }
  },
  methods: {
    GetData () {
      this.errorShow = false
      this.successShow = false
      this.isLoadingSave = false
      // -----------------------------------------------------
      this.records = this.$store.state.customerData.maintenance_request
      this.branches = JSON.parse(localStorage.getItem('Branches'))
      // -----------------------------------------------------
      let i = this.branches.findIndex(x => x.id === parseInt(this.$store.state.customerData.branche_id))
      if (i > -1) {
        this.technicals = this.branches[i].technicals
      }
      // -----------------------------------------------------
      this.record = {}
      this.showForm(0)
    },
    FillGrid () {
      this.showForm(0)
      let i = this.$store.state.customerData.contract.findIndex(x => x.id === this.record.contract_id)
      this.records = this.$store.state.customerData.contract[i].maintenance_request
      if (typeof (this.records) === 'undefined') {
        this.records = []
      }
    },
    showForm (recID) {
      this.errorShow = false
      this.successShow = false
      this.error = ''
      if (recID === 0) {
        this.Localcontract_id = this.record.contract_id
        this.selectedrec = 0
        this.record = {'id': 0, 'contract_id': '', 'request_date': '', 'status': 1, 'notes': '', 'technical_id': ''}
        this.record.contract_id = this.Localcontract_id
      } else {
        this.selectedrec = recID.id
        this.record = {'id': recID.id, 'contract_id': recID.contract_id, 'request_date': recID.request_date, 'status': recID.status, 'notes': recID.notes, 'technical_id': recID.technical_id}
      }
    },
    saveData () {
      this.isLoadingSave = true
      axios.post(this.$apiURL + 'get-next-maintenance', {
        token: localStorage.getItem('token'),
        id: this.record.id,
        contract_id: this.record.contract_id,
        request_date: this.record.request_date,
        notes: this.record.notes,
        status: this.record.status,
        technical_id: this.record.technical_id
      })
        .then(res => {
          this.isLoadingSave = false
          if (this.record.id === 0) {
            this.records.push(res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          } else {
            let i = this.records.map(record => record.id).indexOf(this.record.id)
            this.records.splice(i, 1, res.data)
            this.success = 'تم الحفظ بنجاح'
            this.successShow = true
            this.errorShow = false
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.validationErrors = err.response.data.errors
          this.errorShow = true
          this.isLoadingSave = false
        })
    },
    deleteData (recID) {
      this.isLoadingDelete = true
      axios.post(this.$apiURL + 'deleteMaintenanceRequest', {
        token: localStorage.getItem('token'),
        id: recID
      })
        .then(res => {
          let i = this.records.map(record => record.id).indexOf(recID)
          this.records.splice(i, 1)
          this.isLoadingDelete = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Unauthenticated') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.error = err.message
          this.isLoadingDelete = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/Contracts/MaintenanceRequest.vue